import { useEffect, useId, useRef, useState } from "react";

/**
 * Ícone "i" com explicação ao focar/passar o mouse/tocar.
 * Desktop: tooltip absoluto. Mobile: também funciona no toque (toggle).
 */
export default function FieldInfoTip({ text, label = "Ajuda do campo" }) {
  const tipId = useId();
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onPointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };
    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  if (!text) {
    return null;
  }

  return (
    <span ref={rootRef} className="relative ml-1 inline-flex align-middle">
      <button
        type="button"
        className="inline-flex h-4 w-4 items-center justify-center rounded-full border border-primary/70 bg-black text-[10px] font-bold leading-none text-primary hover:bg-primary/20 focus:outline-none focus-visible:ring-1 focus-visible:ring-primary"
        aria-label={label}
        aria-expanded={open}
        aria-controls={tipId}
        title={text}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setOpen((current) => !current);
        }}
        onFocus={() => setOpen(true)}
        onBlur={(event) => {
          if (!rootRef.current?.contains(event.relatedTarget)) {
            setOpen(false);
          }
        }}
      >
        i
      </button>
      {open ? (
        <span
          id={tipId}
          role="tooltip"
          className="absolute left-1/2 top-[calc(100%+6px)] z-30 w-56 -translate-x-1/2 rounded border border-primary/60 bg-black px-2 py-1.5 text-left text-[11px] font-normal leading-snug text-orange-100 shadow-lg"
        >
          {text}
        </span>
      ) : null}
    </span>
  );
}

export function FieldLabel({ children, help, htmlFor, className = "" }) {
  return (
    <span className={`inline-flex items-center ${className}`.trim()}>
      {htmlFor ? (
        <label htmlFor={htmlFor} className="cursor-pointer">
          {children}
        </label>
      ) : (
        <span>{children}</span>
      )}
      <FieldInfoTip text={help} label={`Ajuda: ${typeof children === "string" ? children : "campo"}`} />
    </span>
  );
}
